/* Author: Soumya Shreyas
 */

import React, { useState, useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { BiTrash, BiUpload, BiChevronRight } from "react-icons/bi";
import { FcFolder, FcImageFile, FcDocument, FcFile } from "react-icons/fc";
import { Breadcrumb, Button, Modal } from "react-bootstrap";
import moment from "moment";
import ErrorHandlingService from "../../../../core/service/ErrorHandlingService";
import DmsService from "../../../../core/service/DmsService";

function Folder({ t, folder, callbackFolder, deleteFolder, regulation }) {
  const [showInfo, setShowInfo] = useState(false);
  const [show, setShow] = useState(false);
  const [showDelMsg, setShowDelMsg] = useState(false);
  const [showRename, setShowRename] = useState(false);
  const [showCheck, setShowCheck] = useState(false);
  const [deleteItem, setDeleteItem] = useState("");
  const [docRename, setDocRename] = useState(folder.name);
  const handleClose = () => setShow(false);
  const handleDelMsgClose = () => setShowDelMsg(false);
  const handleRenameClose = () => setShowRename(false);

  //   document.addEventListener("contextmenu", (event) => {
  //     event.preventDefault();
  //   });
  useEffect(() => {
    document.addEventListener("click", handleClickOuter);
    return () => {
      document.removeEventListener("click", handleClickOuter);
    };
  }, []);

  const handleClick = (e, id, folderName) => {
    e.preventDefault();
    if (e.type === "contextmenu") {
      setShowInfo(!showInfo);
    } else if (e.type === "click") {
      setShowCheck(!showCheck);
      showInfo && setShowInfo(false);
    }
    if (e.detail === 2) {
      //doubleclick
      //   handleOpenFolder(id);
      callbackFolder(id, folderName);
    }
  };
  const handleClickOuter = useCallback(() => {
    setShowInfo(false);
  }, [showInfo]);
  const handleDelete = (e, item) => {
    e.preventDefault();
    setShow(true);
    setShowInfo(false);
    setDeleteItem(item);
  };
  const handleConfirm = (e) => {
    e.preventDefault();
    setShow(false);
    var params = {
      id: deleteItem.id,
    };
    DmsService.deleteRegulationDoc(regulation, deleteItem.id)
      .then((response) => {
        if (response.status === 204) {
          toast.success("Success", {
            position: toast.POSITION.TOP_RIGHT,
          });
        }

        deleteFolder(deleteItem);
      })
      .catch((error) => {
        // if (error.response.status === 400) {
        //   toast.error(error.response.data.message, {
        //     position: toast.POSITION.TOP_RIGHT,
        //   });
        //   //  setShowDelMsg(true);
        // } else {
        //   toast.error(error.message, {
        //     position: toast.POSITION.TOP_RIGHT,
        //   });
        // }
        //ErrorHandlingService.handleError(error.response.status);
      });
  };
  const handleCheckbox = () => setShowCheck(!showCheck);
  const handleRename = (e, folderId, name = "") => {
    e.preventDefault();
    setShowRename(true);
  };
  const handleRenameConfirm = (e) => {
    e.preventDefault();
    setShowRename(false);
    folder.name = docRename;
    DmsService.updateRegulationDoc(regulation, folder.id, folder)
      .then((response) => {
        callbackFolder(folder.container.id, folder.container.name);
      })
      .catch((error) => {});
  };
  const handleMouseLeave = () => {
    showInfo && setShowInfo(false);
  };
  return (
    <>
      <div
        className="Single_DMSFiles"
        onClick={(e) => handleClick(e, folder.id, folder.name)}
        onContextMenu={(e) => handleClick(e, folder.id, folder.name)}
        onMouseLeave={handleMouseLeave}
      >
        <input
          className="form-check-input"
          type="checkbox"
          value=""
          //   checked={showCheck}
          //   onChange={handleCheckbox}
        />
        <label className="form-check-label d-block" htmlFor={folder.id}>
          <div className="Single_DMSFiles_inner">
            <div className="Single_DMSFiles_icon">
              <FcFolder
                onClick={(e) => handleClick(e, folder.id, folder.name)}
                onContextMenu={(e) => handleClick(e, folder.id, folder.name)}
              />
            </div>
            <div className="S-DMSF-Title">{folder.name}</div>
            {regulation && showInfo && (
              <div className="S-DMSF_info">
                <ul>
                  {/* <li>
                      <a href="#">New Folder</a>
                    </li> */}
                  <li>
                    <Link to="#" onClick={(e) => handleRename(e, folder.id)}>
                      {t("Rename.label")}
                    </Link>
                  </li>
                  <li>
                    <a href="#">
                      {t("Information.label")} <BiChevronRight />
                    </a>
                    <div className="Information_Folder">
                      <p>
                        {t("CreatedOn.label")} :{" "}
                        <b>
                          {moment(folder.createdDate).format("MMM DD YYYY")}
                        </b>
                      </p>
                      <p>
                        {t("LastModified.label")} :{" "}
                        <b>
                          {moment(folder.lastModifiedDate).format(
                            "MMM DD YYYY"
                          )}
                        </b>
                      </p>
                      <p>
                        {t("NoofItems.label")} : <b>2</b>
                      </p>
                    </div>
                  </li>
                  <li>
                    <Link to="#" onClick={(e) => handleDelete(e, folder)}>
                      {t("Delete.label")}
                    </Link>
                  </li>
                </ul>
              </div>
            )}
          </div>
        </label>
      </div>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>{t("ConfirmDeleteFolder.label")}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            {t("Close.label")}
          </Button>
          <Button variant="primary" onClick={handleConfirm}>
            {t("Confirm.label")}
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={showRename} onHide={handleRenameClose}>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <div className="p-2">
            <label className="mb-1">{t("EnterFolderName.label")}</label>
            <input
              type="text"
              className="form-control"
              value={docRename}
              onChange={(e) => setDocRename(e.target.value)}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleRenameClose}>
            {t("Close.label")}
          </Button>
          <Button variant="primary" onClick={(e) => handleRenameConfirm(e)}>
            {t("Confirm.label")}
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={showDelMsg} onHide={handleDelMsgClose}>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>{t("CannotDeleteDocument.label")}</Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleDelMsgClose}>
            {t("Ok.label")}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default withTranslation()(Folder);
